<template>
    <div>
        <template v-if="crud_fee_company === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <div class="global-main">
                  <form id="collectionFeeForm" @submit.prevent="addCollectionCompanyData">
                  <div class="px-5 mx-5">
                    <div class="row">
                      <div class="form-group col-3">
                    <h3 class="mt-3 mb-4"> Collection </h3>
                        </div>
                      <div class="form-group col-3">
                    <div class="swither">
                      <label class="swither-inner" for="collection_status">
                        <span class="swither-label"> Off </span>
                        <input v-model="form.collection_status"  id="collection_status" type="checkbox" checked="" />
                        <label class="label-for-input" for="collection_status"> </label>
                        <span class="swither-label"> On </span>
                      </label>
                    </div>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Company <em class="required">*</em></label>
                          <select v-model="form.company_id" name="company_id" @change="selectpickerOnchange()" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('company_id') }" data-live-search="true">
                            <option value="" selected>Select Company</option>
                            <option v-for="record in companies" v-bind:value="record.id" v-bind:key="record.id" v-bind:data-email="record.email" v-bind:data-phone="record.phone" v-bind:data-walletID="record.walletID" >{{record.name}}</option>
                          </select>
                          <has-error :form="form" field="company_id"></has-error>
                        </div>
                        <div class="form-group">
                          <label class="label block-label"> Wallet ID <em class="required">*</em></label>
                          <select id="company" v-model="form.company_id" @change="selectpickerOnchange()" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                            <option value="" selected>Select Wallet ID</option>
                            <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                              {{ company.walletID }}
                            </option>
                          </select>
                          <has-error :form="form" field="company_id"></has-error>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="row align-items-center">
                          <div class="col-2"><label for="" class="label block-label">Creation Type</label></div>
                          <div class="col-2">
                            <label class="radio-holder">
                              Internal
                              <input v-model="form.collection_type" value="internal" type="radio" name="creation-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="col-2">
                            <label class="radio-holder">
                              External
                              <input v-model="form.collection_type" value="external" type="radio" name="creation-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-show="form.collection_type == 'external'">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label> APP BASE URL <em class="required">*</em></label>
                          <input type="text" name="base_url" v-model="form.base_url" class="form-control" :class="{ 'is-invalid': form.errors.has('base_url') }" placeholder="http://finjabusiness.test" />
                          <has-error :form="form" field="base_url"></has-error>
                        </div>
                        <div class="form-group">
                          <label> APP ID <em class="required">*</em></label>
                          <input type="text" name="app_id" v-model="form.app_id" class="form-control" :class="{ 'is-invalid': form.errors.has('app_id') }" placeholder="APP ID" />
                          <has-error :form="form" field="app_id"></has-error>
                        </div>
                        <div class="form-group">
                          <label> APP KEY <em class="required">*</em></label>
                          <input type="text" name="app_key" v-model="form.app_key" class="form-control" :class="{ 'is-invalid': form.errors.has('app_key') }" placeholder="APP KEY" />
                          <has-error :form="form" field="app_key"></has-error>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="collection-box">
                          <div class="box-head">
                            <span class="title"> Creation </span>
                            <div class="swither">
                              <label class="swither-inner" for="creation_fee_status">
                                <span class="swither-label"> Off </span>
                                <input v-model="form.creation_fee_status"  id="creation_fee_status" type="checkbox" checked="" />
                                <label class="label-for-input" for="creation_fee_status"> </label>
                                <span class="swither-label"> On </span>
                              </label>
                            </div>
                          </div>
                          <div class="box-inner-content">
                            <span class="title"> Creation Charges </span>
                            <label class="radio-holder">
                              Fix
                              <input type="radio" v-model="form.creation_charges_type" value="fixed" name="creation-charges-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <label class="radio-holder">
                              Percentage
                              <input type="radio" v-model="form.creation_charges_type" value="percentage" name="creation-charges-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <span class="title"> FED </span>
                            <label class="radio-holder">
                              Inclusive
                              <input type="radio" v-model="form.creation_fed_type" value="inclusive" name="creation-fed-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <label class="radio-holder">
                              Exclusive
                              <input type="radio" v-model="form.creation_fed_type" value="exclusive" name="creation-fed-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <div class="form-group mt-3">
                              <span class="title"> Collection Creation Charges  <strong v-if="form.creation_charges_type == 'percentage'">(%)</strong> <strong v-if="form.creation_charges_type == 'fixed'">(Rs.)</strong></span>
                              <input type="number" min="0" step=".01" v-model="form.creation_charges" class="form-control" placeholder="Creation Charges" required />
                            </div>
                            <div class="form-group" v-if="form.creation_charges_type == 'percentage'">
                              <span class="title"> Max Creation Charges <strong>(Rs.)</strong> </span>
                              <input type="number" min="0" step=".01" v-model="form.max_creation_charges" class="form-control" placeholder="Max Creation Charges" required />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="collection-box">
                          <div class="box-head">
                            <span class="title"> Consumption </span>
                            <div class="swither">
                              <label class="swither-inner" for="consumption_fee_status">
                                <span class="swither-label"> Off </span>
                                <input v-model="form.consumption_fee_status" id="consumption_fee_status" type="checkbox" checked="" />
                                <label class="label-for-input" for="consumption_fee_status"> </label>
                                <span class="swither-label"> On </span>
                              </label>
                            </div>
                          </div>
                          <div class="box-inner-content">
                            <span class="title"> Consumption Charges </span>
                            <label class="radio-holder">
                              Fix
                              <input type="radio" v-model="form.consumption_charges_type" value="fixed" name="consumption-charges-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <label class="radio-holder">
                              Percentage
                              <input type="radio" v-model="form.consumption_charges_type" value="percentage" name="consumption-charges-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <span class="title"> FED </span>
                            <label class="radio-holder">
                              Inclusive
                              <input type="radio" v-model="form.consumption_fed_type" value="inclusive" name="consumption-fed-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <label class="radio-holder">
                              Exclusive
                              <input type="radio" v-model="form.consumption_fed_type" value="exclusive" name="consumption-fed-type" checked="">
                              <span class="checkmark"></span>
                            </label>
                            <div class="form-group mt-3">
                              <span class="title"> Collection Consumption Charges <strong v-if="form.consumption_charges_type == 'percentage'">(%)</strong> <strong v-if="form.consumption_charges_type == 'fixed'">(Rs.)</strong> </span>
                              <input type="number" min="0" step=".01" v-model="form.consumption_charges" class="form-control" placeholder="Consumption Charges" required />
                            </div>
                            <div class="form-group" v-if="form.consumption_charges_type == 'percentage'">
                              <span class="title"> Max Consumption Charges <strong>(Rs.)</strong> </span>
                              <input type="number" min="0" step=".01" v-model="form.max_consumption_charges" class="form-control" placeholder="Max Consumption Charges" required />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-right mt-5">
<!--                        <button class="btn btn-primary mr-1"> Cancel </button>-->
<!--                        <button class="btn btn-primary"> Submit </button>-->
                        <router-link to="/feeCompanies" class="btn btn-primary mr-1">Cancel</router-link>
                        <button :disabled="form.busy" class="btn btn-primary  active">Submit</button>
                      </div>
                    </div>
                  </div>
                  </form>
                </div>
              </div>
        </template>
        <template v-else-if="crud_fee_company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_fee_company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form : new Form({
                    company_id : '',
                    collection_status : true,
                    creation_fee_status : true,
                    consumption_fee_status : true,
                    creation_charges_type : 'percentage',
                    consumption_charges_type : 'percentage',
                    creation_fed_type : 'exclusive',
                    consumption_fed_type : 'exclusive',
                    creation_charges : 0,
                    consumption_charges : 0,
                    max_creation_charges : 100,
                    max_consumption_charges : 100,
                    collection_type : 'internal',
                    fee_code : '',
                    app_id : null,
                    app_key : null,
                    base_url : null,
                }),
                company : {
                    email : '',
                    phone : '',
                    walletID : ''
                },
                companies : null,
                crud_fee_company : null,
            }
        },
        methods: {
            addCollectionCompanyData() {
                this.$Progress.start();
                this.form.post('/api/addCollectionCompany')
                .then(res => {
                    if(res.status == 200){
                        this.resetForm();
                        this.$Progress.finish();
                        this.showToastBox('success','Company has been added as collection');
                        this.$router.push('/feeCompanies');
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            getAddCollectionCompanyData(){
                this.$Progress.start();
                axios.get('/api/addCollectionCompanyData')
                .then(res => {
                    if(res.status == 200){
                        this.companies = res.data.companies;
                        this.form.fee_code = res.data.fee_code;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
          selectpickerOnchange(){
            var select=this.$el;
            setTimeout(()=>{
              $(select).find('.selectpicker').selectpicker('refresh');
            },0);
          },
          resetForm() {
            this.form.company_id = "";
            this.form.max_creation_charges = "";
            this.form.creation_charges = "";
            this.form.consumption_charges = "";
            this.form.max_consumption_charges = "";
            this.form.fee_code = "";
          },
        },
        mounted() {
            this.$Progress.start();
            var that = this;
            this.can('crud_fee_company').then(result => {
                this.crud_fee_company = result.crud_fee_company;
            }).then(result => {
                if(this.crud_fee_company == true){
					this.getAddCollectionCompanyData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
            window.changeParams = function(obj){
                that.company.email = $(obj).children("option:selected").attr('data-email');
                that.company.phone = $(obj).children("option:selected").attr('data-phone');
                that.company.walletID = $(obj).children("option:selected").attr('data-walletID');
            }
        },
    }
</script>
